import React from "react";
import { useLocation } from "react-router-dom";
import { IconRotateClockwise } from "@tabler/icons-react";
import resumenClinicoVideo from "../../assets/videos/presentacion-caso-sc1-intro.mp4";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import { useVideoWithSound } from "../../hooks/useVideoWithSound";
import "../StartGame.css";
import "../Scenario1/Scenario1Intro.css";
import Scenario2NextCta from "./Scenario2NextCta";
import "./Scenario2.css";

export default function Scenario2Context1() {
	const location = useLocation();
	const activeScenario = getScenarioNumByPath(location.pathname);
	const { videoRef, canPlayWithSound } = useVideoWithSound({
		autoPlay: true,
		volume: 1.0,
	});

	const handleReplayFromStart = () => {
		const el = videoRef.current;
		if (!el) return;
		el.currentTime = 0;
		el.play().catch(() => {});
	};

	return (
		<>
			<div className="s1-intro-page start-game-page--welcome sc2-context1-intro">
				<div className="s1-intro-inner">
					<span className="start-game-badge s1-intro-badge">
						<span className="start-game-badge-dot" aria-hidden />
						Escenario 1 · Llegada y control de la situación
					</span>

					<div className="s1-intro-video-frame">
						<video
							ref={videoRef}
							autoPlay
							muted={!canPlayWithSound}
							playsInline
							preload="metadata"
							aria-label="Resumen clínico en vídeo"
						>
							<source src={resumenClinicoVideo} type="video/mp4" />
						</video>
					</div>

					<div className="s1-intro-footer">
						<button
							type="button"
							className="s1-intro-replay s1-intro-replay--icon"
							aria-label="Volver a reproducir el vídeo desde el principio"
							onClick={(e) => {
								e.preventDefault();
								handleReplayFromStart();
							}}
						>
							<IconRotateClockwise size={22} stroke={1.75} aria-hidden />
						</button>
						<Scenario2NextCta
							navigateTo={ROUTES.SCENARIO2_QUIZ1}
							activeScenario={activeScenario}
							className="s1-intro-cta"
							label="Continuar"
						/>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</>
	);
}
